const isModifiedClick = (event) => {
  return Boolean(
    event
    && (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)
  );
};

export const buildRouteDetailLocation = (routeName, paramKey, id, query = null) => {
  const normalizedId = Number(id || 0);
  if (!normalizedId) {
    return null;
  }

  const routeLocation = {
    name: routeName,
    params: { [paramKey]: normalizedId },
  };

  if (query && typeof query === 'object') {
    routeLocation.query = query;
  }

  return routeLocation;
};

export const resolveRouteHref = (router, routeName, paramKey, id, query = null) => {
  const normalizedId = Number(id || 0);
  if (!normalizedId) {
    return '#';
  }

  const routeLocation = router.resolve({
    name: routeName,
    params: { [paramKey]: normalizedId },
    query: query || undefined,
  });

  return routeLocation?.href || '#';
};

export const navigateToRouteDetail = (router, routeName, paramKey, id, event = null, query = null) => {
  const normalizedId = Number(id || 0);
  if (!normalizedId) {
    return;
  }

  if (isModifiedClick(event)) {
    return;
  }

  if (event) {
    event.preventDefault();
  }

  router.push({
    name: routeName,
    params: { [paramKey]: normalizedId },
    query: query || undefined,
  }).catch(() => {});
};
